import PromericaSection from './PromericaSection';
export default PromericaSection;
